module.exports = " <div v-if=searchItems.length id=search-result> <span class=close-search-result @click=closeSearchResult>&times;</span> <ul class=container> <song v-for=\"item in searchItems\" :item=item :add-to-playlist-btn=true></song> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SearchResult.vue
// module id = 165
// module chunks = 2